import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'nl2br'})

export class ReplaceLineBreaksPipe implements PipeTransform {
  transform(value: string): string {

    if(value === null || value === undefined ){
      return '';
    }
    return value.replace(/(\r\n|\n|\r)+/g, '<br/>');
  }
}
